import { useCallback } from 'react';
import { getMetricInfo } from '../../constants';

const useNext = ({ generalForm, setAlert, alert }) => {
  const onNext = useCallback(
    (callback) => {
      const metricsInfo = getMetricInfo();
      generalForm
        .validateFields()
        .then((values) => {
          const currentGeneralSettings = values;
          const metric = currentGeneralSettings.metric;
          let extra = {};
          if (!alert.id) {
            extra = !alert.samples ? { samples: metricsInfo[metric].cm_value } : {};
          }
          setAlert({ ...alert, ...currentGeneralSettings, ...extra });
          callback();
        })
        .catch((err) => {
          console.error('Validation failed:', err);
        });
    },
    [generalForm.current, alert],
  );
  return onNext;
};

export default useNext;
